import axios from 'axios';
import { banqoraGraphQLApi } from '~/api/def/servers/defaultServer';
import { getToken } from '~/lib/graphql/graphQLClient';

export const banqoraGraphQLEndpoint = {
  server: banqoraGraphQLApi,
  path: 'api/v1/execute-query',
  description: 'Execute GraphQL query on Banqora GraphQL API',
};

export const banqoraGraphQLEndpointPOST = async (
  payload: BanqoraGraphQLRequest,
): Promise<BanqoraGraphQLResponse> => {
  const token = await getToken();
  const formattedQuery = payload.query.replace(/\\n/g, '\n').trim();
  const encodedQuery = encodeURIComponent(formattedQuery);
  const url = `${banqoraGraphQLApi.url}${banqoraGraphQLEndpoint.path}?query=${encodedQuery}`;

  try {
    const response = await axios.post(url, null, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Banqora GraphQL API error:', error);
    throw error;
  }
};

export interface BanqoraGraphQLEndpointDef {
  endpoint: typeof banqoraGraphQLEndpoint;
  methods: {
    POST: {
      response: BanqoraGraphQLResponse;
      payload: BanqoraGraphQLRequest;
    };
  };
}

export interface BanqoraGraphQLRequest {
  query: string;
  variables?: Record<string, unknown>;
}

export type BanqoraGraphQLResponse = {
  success: boolean;
  data: Record<string, unknown>[];
  error: string | null;
  query_info: {
    entity: string;
    group_by: string[];
    aggregations: Record<
      string,
      {
        function: string;
        field: string;
      }
    >;
    row_count: number;
  };
};
